(function ()
{
  /* ---- settings ---------------------------------------------------- */
  /* Extra link texts on the page that should also open THIS lightbox.
     NOTE: "why it's effective" is deliberately NOT here - that link drives
     the store's own separate lightbox ("Why The VitalSleep Snore Guard?").
     Both lightboxes run on this PDP on purpose. Do not bind theirs. */
  var VS_MATCH_TEXT = ["the science", "a special message for you"];
  /* "session" = doors reappear on the next visit. "forever" = never again. */
  var VS_SCOPE = "session";
  var KEY = "vsStorySeen";

  var modal = document.getElementById("vs-story");
  if (!modal)
  {
    return;
  }

  var store = null;
  try
  {
    store = (VS_SCOPE === "forever") ? window.localStorage : window.sessionStorage;
    store.getItem(KEY);
  }
  catch (e)
  {
    store = null;
  }
  var memo = false;

  function seen ()
  {
    if (store)
    {
      return store.getItem(KEY) === "1";
    }
    return memo;
  }

  function markSeen ()
  {
    memo = true;
    if (store)
    {
      try
      {
        store.setItem(KEY, "1");
      }
      catch (e) {}
    }
  }

  /* ---- find every trigger on the page ------------------------------ */
  function triggers ()
  {
    var out = [];
    var tagged = document.querySelectorAll("[data-vs-story]");
    var i;
    for (i = 0; i < tagged.length; i++)
    {
      out.push(tagged[i] );
    }
    var links = document.getElementsByTagName("a");
    for (i = 0; i < links.length; i++)
    {
      var a = links[i];
      if (a.hasAttribute("data-vs-story") )
      {
        continue;
      }
      var t = (a.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      t = t.replace(/[.,:;!?\u2192\u2190]+$/, "").trim();
      if (VS_MATCH_TEXT.indexOf(t) > -1)
      {
        a.setAttribute("data-vs-story", "auto");
        out.push(a);
      }
    }
    return out;
  }

  /* ---- hide every door except the one they used -------------------- */
  function collapse (used)
  {
    var all = triggers();
    for (var i = 0; i < all.length; i++)
    {
      if (all[i] === used)
      {
        continue;
      }
      var node = all[i];
      var cue = node.closest ? node.closest(".vs-story-cue") : null;
      (cue || node).setAttribute("data-vs-hidden", "1");
    }
  }

  /* ---- open / close ------------------------------------------------ */
  var lastFocus = null;
  var scrollY = 0;

  function open (used)
  {
    lastFocus = used || document.activeElement;
    scrollY = window.pageYOffset || document.documentElement.scrollTop;
    modal.setAttribute("data-vs-open", "1");
    document.body.style.top = "-" + scrollY + "px";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    markSeen();
    collapse(used);
    var x = modal.querySelector(".vs-story-x");
    if (x)
    {
      x.focus();
    }
  }

  function close ()
  {
    modal.removeAttribute("data-vs-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollY);
    if (window.location.hash === "#vs-story")
    {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
    if (lastFocus && lastFocus.focus)
    {
      lastFocus.focus();
    }
  }

  /* ---- wire it up -------------------------------------------------- */
  document.addEventListener("click", function (ev)
  {
    var t = ev.target;
    var hit = t.closest ? t.closest("[data-vs-story]") : null;
    if (hit)
    {
      ev.preventDefault();
      open(hit);
      return;
    }
    var off = t.closest ? t.closest(".vs-story-x, .vs-story-scrim") : null;
    if (off)
    {
      ev.preventDefault();
      close();
      return;
    }
    var buy = t.closest ? t.closest("[data-vs-buy]") : null;
    if (buy)
    {
      var target = buyAnchor();
      if (target)
      {
        ev.preventDefault();
        close();
        setTimeout(function ()
        {
          var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          target.scrollIntoView(
          {
            behavior: reduce ? "auto" : "smooth",
            block: "center"
          } );
        }, 60);
      }
    }
  }, false);

  document.addEventListener("keydown", function (ev)
  {
    /* only act when OUR lightbox is open, so ESC still belongs to the
       store's own lightbox when that one is the open dialog */
    if (!modal.hasAttribute("data-vs-open") )
    {
      return;
    }
    if (ev.key === "Escape")
    {
      close();
      return;
    }
    /* keep Tab inside the dialog, otherwise focus wanders onto the
       page behind the scrim, which is invisible to a keyboard user */
    if (ev.key === "Tab")
    {
      var f = modal.querySelectorAll('a[href]:not([tabindex="-1"] ), button:not([disabled] ):not([tabindex="-1"] ), [tabindex="0"]');
      var list = [];
      for (var i = 0; i < f.length; i++)
      {
        if (f[i].offsetParent !== null)
        {
          list.push(f[i] );
        }
      }
      if (!list.length)
      {
        return;
      }
      var first = list[0];
      var last = list[list.length - 1];
      if (ev.shiftKey && document.activeElement === first)
      {
        ev.preventDefault();
        last.focus();
      }
      else if (!ev.shiftKey && document.activeElement === last)
      {
        ev.preventDefault();
        first.focus();
      }
    }
  }, false);

  /* ---- on load: tag the doors, then drop the extras if already read -- */
  function sweep ()
  {
    triggers();
    if (seen() )
    {
      collapse(null);
    }
  }

  var moved = false;

  /* Find the buy box. This theme does NOT use a standard cart form on the
     PDP - the button is #btnCTA driven by fetch() - so a form-only lookup
     finds nothing. Try several shapes, most specific first. */
  function buyAnchor ()
  {
    var el = document.querySelector('form[action*="/cart/add"]');
    if (el)
    {
      return el.closest(".vs-buy, .product-form, .shopify-product-form") || el;
    }
    el = document.getElementById("btnCTA");
    if (el)
    {
      return el.closest(".vs-buy, .vs-buybox, .product-form, form") || el;
    }
    var cands = document.querySelectorAll("button, a, input[type=\"submit\"]");
    for (var i = 0; i < cands.length; i++)
    {
      var c = cands[i];
      var label = (c.textContent || c.value || "").replace(/\s+/g, " ").trim();
      if (/add\s+.*\bto\s+cart\b/i.test(label) && c.offsetParent !== null)
      {
        return c.closest(".vs-buy, .vs-buybox, .product-form, form") || c;
      }
    }
    return document.querySelector("h1");
  }

  /* FAIL OPEN. The CSS hides the trigger only while it is still inside
     .vs-story-wrap. If we can never find a buy box, reveal it where it is
     rather than leaving it invisible - a link in an odd spot is a bug you
     can see, an invisible one is a bug you cannot. */
  function reveal ()
  {
    var cue = document.querySelector(".vs-story-cue");
    if (cue)
    {
      cue.setAttribute("data-vs-shown", "1");
    }
  }

  /* ---- extra doors, above the fold --------------------------------- */
  /* ADJUST HERE: how far down the page still counts as "above the fold"
     for placing a door. This is VIEWPORT-RELATIVE on purpose. A fixed
     pixel number means "above the fold" on a 1440px desktop and well
     BELOW it on a 390x844 phone, so a door could be placed 1400px down
     where a phone shopper never sees it. One viewport height is the
     honest definition, clamped so a very short or very tall window
     cannot make it absurd. */
  var VS_FOLD_MIN = 640;
  var VS_FOLD_MAX = 1500;

  function foldDepth ()
  {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!vh)
    {
      return VS_FOLD_MAX;
    }
    if (vh < VS_FOLD_MIN)
    {
      return VS_FOLD_MIN;
    }
    if (vh > VS_FOLD_MAX)
    {
      return VS_FOLD_MAX;
    }
    return vh;
  }

  function aboveFold (el)
  {
    var top = el.getBoundingClientRect().top + (window.pageYOffset || 0);
    return top > 0 && top < foldDepth();
  }

  /* The benefit bullet list in the buy box, i.e. where the original
     "A special message for you" link used to sit. Take the last list that
     is above the fold and sits BEFORE the buy button in document order. */
  function bulletAnchor ()
  {
    var buy = buyAnchor();
    var lists = document.querySelectorAll("ul, ol");
    var best = null;
    for (var i = 0; i < lists.length; i++)
    {
      var ul = lists[i];
      if (modal.contains(ul) || ul.querySelector(".vs-story-cue") )
      {
        continue;
      }
      /* The PDP also runs its OWN lightbox ("Why The VitalSleep Snore
         Guard?"), and its markup contains a bullet list. Never drop a door
         inside another dialog - it would only appear once that dialog is
         open, which is not where anyone would look for it. */
      if (ul.closest && ul.closest('[role="dialog"], [aria-modal="true"], .modal, .popup, #popup') )
      {
        continue;
      }
      if (ul.getElementsByTagName("li").length < 2)
      {
        continue;
      }
      if (!aboveFold(ul) )
      {
        continue;
      }
      if (buy && !(ul.compareDocumentPosition(buy) & Node.DOCUMENT_POSITION_FOLLOWING) )
      {
        continue;
      }
      best = ul;
    }
    return best;
  }

  function titleAnchor ()
  {
    var h = document.querySelector("h1");
    if (!h || !aboveFold(h) )
    {
      return null;
    }
    var next = h.nextElementSibling;
    if (next && next.tagName === "P" && aboveFold(next) )
    {
      return next;
    }
    return h;
  }

  function addDoor (anchor, cue)
  {
    if (!anchor || !cue || modal.contains(anchor) )
    {
      return false;
    }
    /* only skip if THIS anchor already has a door right after it - an
       earlier version checked the whole parent, which blocked every extra
       door inside the buy box because the buy-box door was already there */
    var nxt = anchor.nextElementSibling;
    if (nxt && nxt.className && String(nxt.className).indexOf("vs-story-cue") > -1)
    {
      return false;
    }
    anchor.insertAdjacentElement("afterend", cue);
    return true;
  }

  function relocate ()
  {
    if (moved)
    {
      return;
    }
    var cue = document.querySelector(".vs-story-cue");
    if (!cue)
    {
      return;
    }
    var anchor = buyAnchor();
    if (!anchor || anchor.contains(cue) || cue.contains(anchor) )
    {
      return;
    }
    anchor.insertAdjacentElement("afterend", cue);
    cue.setAttribute("data-vs-shown", "1");
    moved = true;

    /* ADJUST HERE: extra doors above the fold. Each is a clone of the same
       link, so they all open the same lightbox, and opening any one of them
       hides the rest for the session. Remove an entry to drop that door. */
    var extra = [bulletAnchor()];
    /* Add titleAnchor() to the array above for a THIRD door under the
       product title. Left off by default: on this PDP the title, bullets
       and buy button all sit in the same right-hand column, so three
       identical links land within about 200px of each other. */
    for (var i = 0; i < extra.length; i++)
    {
      if (!extra[i])
      {
        continue;
      }
      var clone = cue.cloneNode(true);
      clone.setAttribute("data-vs-shown", "1");
      addDoor(extra[i], clone);
    }
  }

  function init ()
  {
    relocate();
    sweep();
    /* GemPages and app blocks inject markup after load, so keep watching
       for late-arriving trigger links and a late-arriving buy box. */
    if (window.MutationObserver)
    {
      var pending = 0;
      var mo = new MutationObserver(function ()
      {
        clearTimeout(pending);
        pending = setTimeout(function ()
        {
          relocate();
          sweep();
        }, 250);
      } );
      mo.observe(document.body,
      {
        childList: true,
        subtree: true
      } );
      setTimeout(function ()
      {
        mo.disconnect();
        reveal();
      }, 15000);
    }
    setTimeout(reveal, 2500);
  }
  if (document.readyState === "loading")
  {
    document.addEventListener("DOMContentLoaded", init);
  }
  else
  {
    init();
  }

  /* ---- figures: hide unfilled slots, make filled ones responsive ---- */
  function figures ()
  {
    var figs = modal.querySelectorAll(".vs-story-fig");
    for (var i = 0; i < figs.length; i++)
    {
      var fig = figs[i];
      var im = fig.querySelector("img");
      var src = im ? (im.getAttribute("src") || "").trim() : "";

      if (!src)
      {
        fig.setAttribute("data-vs-empty", "1");
        continue;
      }
      fig.removeAttribute("data-vs-empty");

      /* lock the box so the modal doesn't jump while the file loads */
      var w = parseInt(im.getAttribute("width"), 10);
      var h = parseInt(im.getAttribute("height"), 10);
      if (w > 0 && h > 0 && !im.style.aspectRatio)
      {
        im.style.aspectRatio = w + " / " + h;
      }
      /* Most assets on this store are smaller than the 620px column.
         Cap each one at its own native width and centre it, rather than
         stretching a 520px file across 612px and making it look soft. */
      if (w > 0)
      {
        im.style.maxWidth = w + "px";
      }

      /* Shopify CDN can resize on the fly, so serve a phone-sized file
         to phones instead of the full-width original. Never ask for more
         than the file actually has, Shopify will not upscale, and a
         lying descriptor makes the browser pick the wrong candidate. */
      if (src.indexOf("cdn.shopify.com") > -1 && !im.getAttribute("srcset") )
      {
        var join = (src.indexOf("?") > -1) ? "&" : "?";
        var want = [420, 640, 960, 1280];
        var set = [];
        for (var k = 0; k < want.length; k++)
        {
          if (!w || want[k] < w)
          {
            set.push(src + join + "width=" + want[k] + " " + want[k] + "w");
          }
        }
        if (w > 0)
        {
          set.push(src + " " + w + "w");
        }
        if (set.length > 1)
        {
          im.setAttribute("srcset", set.join(", ") );
          im.setAttribute("sizes", "(max-width: 640px) 100vw, 620px");
        }
      }

      im.addEventListener("error", function ()
      {
        var f = this.closest ? this.closest(".vs-story-fig") : null;
        if (f)
        {
          f.setAttribute("data-vs-empty", "1");
        }
      }, false);
    }
  }
  figures();
} )();
